import React, { useState } from 'react';
import { Section } from '../../../../fc-components/main/components';
import MarketoForm from '../../../../components/MarketoForm/MarketoForm';
import PropTypes from 'prop-types';

const MarketoNewsletterForm = ({ handleSubmission }) => {
  const [checkedCompass, setCheckCompass] = useState(true);
  const [checkedCodesign, setCheckCodesign] = useState(true);
  const [checkedImpact, setCheckImpact] = useState(true);
  const [checkedPlugged, setCheckPlugged] = useState(true);
  const [checkedModernCeo, setCheckedModernCeo] = useState(true);

  const handleCheckCompass = () => {
    setCheckCompass(!checkedCompass);
    if (checkedCompass) {
      document.getElementsByName('optInFCCompassNewsletter')[0].checked = false;
    } else {
      document.getElementsByName('optInFCCompassNewsletter')[0].checked = true;
    }
  };

  const handleCheckCodesign = () => {
    setCheckCodesign(!checkedCodesign);
    if (checkedCodesign) {
      document.getElementsByName(
        'optInFCCoDesignNewsletter'
      )[0].checked = false;
    } else {
      document.getElementsByName('optInFCCoDesignNewsletter')[0].checked = true;
    }
  };

  const handleCheckImpact = () => {
    setCheckImpact(!checkedImpact);
    if (checkedImpact) {
      document.getElementsByName('optInFCImpactNewsletter')[0].checked = false;
    } else {
      document.getElementsByName('optInFCImpactNewsletter')[0].checked = true;
    }
  };

  const handleCheckPlugged = () => {
    setCheckPlugged(!checkedPlugged);
    if (checkedPlugged) {
      document.getElementsByName(
        'optInFCPluggedInNewsletter'
      )[0].checked = false;
    } else {
      document.getElementsByName(
        'optInFCPluggedInNewsletter'
      )[0].checked = true;
    }
  };

  const handleCheckModernCeo = () => {
    setCheckedModernCeo(prev => !prev);
    if (checkedModernCeo) {
      document.getElementsByName(
        'optInFCModernCEONewsletter'
      )[0].checked = false;
    } else {
      document.getElementsByName(
        'optInFCModernCEONewsletter'
      )[0].checked = true;
    }
  };

  return (
    <Section bgColor="#F4F4F4" noPadding>
      <div className="newsletters__page__marketo">
        <div className="newsletters__page__marketo__form__container">
          <div className="options">
            <section>
              <div className="timeFrame">
                <p> Daily </p>
                <label className="inputgroup">
                  <input
                    type="checkbox"
                    checked={checkedCompass}
                    onChange={handleCheckCompass}
                  />
                  <span className="checkbox" />
                </label>
              </div>
              <img
                src="https://assets.fastcompany.com/image/upload/v1670274719/fc-newsletter-logo.svg"
                alt=""
              />
              <p className="description">
                Fast Company’s trending stories delivered to you daily
              </p>
            </section>
            <section>
              <div className="timeFrame">
                <p> Weekdays </p>
                <label className="inputgroup">
                  <input
                    type="checkbox"
                    checked={checkedCodesign}
                    onChange={handleCheckCodesign}
                  />
                  <span className="checkbox" />
                </label>
              </div>
              <img
                src="https://assets.fastcompany.com/image/upload/v1670274604/fc-newsletter-logo_CoDesign.svg"
                alt=""
              />
              <p className="description">
                Our design newsletter curated by deputy digital Editor Morgan
                Clendaniel
              </p>
            </section>
            <section>
              <div className="timeFrame">
                <p> Weekly </p>
                <label className="inputgroup">
                  <input
                    type="checkbox"
                    checked={checkedImpact}
                    onChange={handleCheckImpact}
                  />
                  <span className="checkbox" />
                </label>
              </div>
              <img
                src="https://assets.fastcompany.com/image/upload/v1670274672/fc-newsletter-logo_impact.svg"
                alt=""
              />
              <p className="description">
                A roundup of our social impact coverage
              </p>
            </section>
            <section>
              <div className="timeFrame">
                <p> Weekly </p>
                <label className="inputgroup">
                  <input
                    type="checkbox"
                    checked={checkedPlugged}
                    onChange={handleCheckPlugged}
                  />
                  <span className="checkbox" />
                </label>
              </div>
              <img
                src="https://assets.fastcompany.com/image/upload/v1670274702/fc-newsletter-logo_pluggedin.svg"
                alt=""
              />
              <p className="description">
                Exploration of innovation in technology
              </p>
            </section>
            <section>
              <div className="timeFrame">
                <p> Weekly </p>
                <label className="inputgroup">
                  <input
                    type="checkbox"
                    checked={checkedModernCeo}
                    onChange={handleCheckModernCeo}
                  />
                  <span className="checkbox" />
                </label>
              </div>
              <img
                src="https://assets.fastcompany.com/image/upload/v1675184658/fc-newsletter-logo_modern_ceo.svg"
                alt="Modern CEO Newsletter"
              />
              <p className="description">
                A refreshed look at leadership from CEO and chief content
                officer Stephanie Mehta
              </p>
            </section>
          </div>
          <MarketoForm assetId={1211} onSubmitHandler={handleSubmission} />
        </div>
      </div>
    </Section>
  );
};

export default MarketoNewsletterForm;

MarketoNewsletterForm.propTypes = {
  handleSubmission: PropTypes.func.isRequired
};
